import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import CloseModal from '../CloseModal';
import { collectFormValues } from 'validate.js';
import "./styles.css";
import { connect } from "react-redux";
import * as actions from "redux/actions/stockOrderActions";
import { Link as RouterLink } from "react-router-dom";
import ReferenceModal from '../ReferenceModal';
import { Translate, I18n } from "react-redux-i18n";
import { confirmDelete } from 'utils/confirmDialog';
import { getPortfolioRowClassName, toggleRowSelected } from 'utils/tableRowSelect';
import ActionBtnRight from './components/ActionBtnRight';
import StockAvatar from 'components/StockAvatar';
import { Star,AngleDown,AngleRight,Circle,AccessTime, Trash } from "theme/icon"


const stylesLocal = {
    subcell: {
        padding: "5px",
        // fontWeight: "bold",
        color: "black"
    },
    cell: {
        padding: "5px",
        // fontWeight: "bold",
        color: "black"
    },
    avatar: {

    }
};
const useStyles = {
    avatar: {
        marginRight: '7px',
        height: 30,
        width: 30,
        flexDirection: 'row',
        position: "absolute",
        borderRadius: "5px"

    },

};

const Row = props => {
    const { className, order, key, ...rest } = props;

    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(false);
    const [selectedSubId, setSelectedSubId] = useState(null);


    // const [openModalReference, setOpenModalReference] = useState(false);
    //const [reference, setReference] = useState("");

    const onClickDelete = (item) => {
        confirmDelete(
            I18n.t('delete_confirm_message'),
            () => {
                if (item.counter > 1) {
                    props.removeSymbol(props.token, { symbol: item.symbol, id: props.user_id });
                } else {
                    props.removeItem(props.token, { stock_id: item.id, symbol: item.symbol, id: props.user_id });
                }
            },
        );

    };
    /*
        const onClickEdit = (item) => {
            setReference(item.reference);
            setOpenModalReference(true);
        };
    
        const handleClose = (item) => {
            setOpenModalReference(false);
            setReference("");
        };
    
        const handleSave = (item) => {
            setOpenModalReference(false);
            props.updateReference(props.token,
                {
                    stock_id: item.id,
                    reference: reference,
                    symbol: item.symbol,
                    id: props.user_id,
                });
            setReference("");
        };
    
        const handleChange = (event) => {
            setReference(event.target.value);
        };
    */
    const getPrice = (item) => {
        const live = props.stock[item.symbol];
        const current = Number(live?.c);
        const previousClose = Number(live?.pc);
        if (current > 0) {
            return current;
        }
        if (previousClose > 0) {
            return previousClose;
        }
        const fallback = Number(item.price);
        return fallback > 0 ? fallback : 0;
    };

    const calcPl = (quantity, openPrice, currentPrice, market) => {
        const qty = Number(quantity);
        const open = Math.abs(Number(openPrice));
        const current = Number(currentPrice);
        if (!qty || !current || Number.isNaN(open)) {
            return null;
        }
        if (market === 'SELL') {
            return qty * (open - current);
        }
        return qty * (current - open);
    };

    const calcPlPercent = (openPrice, currentPrice, market) => {
        const open = Math.abs(Number(openPrice));
        const current = Number(currentPrice);
        if (!current || Number.isNaN(open)) {
            return null;
        }
        const absOpen = Math.abs(open);
        if (!absOpen) {
            return null;
        }
        if (market === 'SELL') {
            return ((open - current) / absOpen) * 100;
        }
        return (( current - open ) / absOpen) * 100;
    };

    const getOrderPl = (orderRow, currentPrice) => {
        if (orderRow.counter > 1 && orderRow.sub_order?.length) {
            let total = 0;
            let hasValue = false;
            orderRow.sub_order.forEach((sub) => {
                const pl = calcPl(sub.quantity, sub.open_price, currentPrice, sub.market);
                if (pl != null) {
                    total += pl;
                    hasValue = true;
                }
            });
            return hasValue ? total : null;
        }
        return calcPl(orderRow.quantity, orderRow.open_price, currentPrice, orderRow.market);
    };

    const getOrderPlPercent = (orderRow, currentPrice) => {
        if (orderRow.counter > 1 && orderRow.sub_order?.length) {
            const pl = getOrderPl(orderRow, currentPrice);
            const invested = orderRow.sub_order.reduce(
                (sum, sub) => sum + Math.abs(Number(sub.open_trade) || 0),
                0,
            );
            if (pl == null || !invested) {
                return null;
            }
            return (pl / invested) * 100;
        }
        return calcPlPercent(orderRow.open_price, currentPrice, orderRow.market);
    };

    const formatPl = (value) => {
        if (value == null || Number.isNaN(value)) {
            return '—';
        }
        return Number(value).toFixed(2);
    };

    const getAverageOpenPrice = (orderRow) => {
        if (orderRow.counter > 1 && orderRow.sub_order?.length) {
            let totalQty = 0;
            let weightedSum = 0;
            orderRow.sub_order.forEach((sub) => {
                const qty = Math.abs(Number(sub.quantity) || 0);
                const price = Math.abs(Number(sub.open_price));
                if (!qty || Number.isNaN(price)) {
                    return;
                }
                totalQty += qty;
                weightedSum += qty * price;
            });
            if (!totalQty) {
                return null;
            }
            return weightedSum / totalQty;
        }
        const price = Math.abs(Number(orderRow.open_price));
        return Number.isNaN(price) ? null : price;
    };

    const currentPrice = getPrice(order);
    const orderPl = getOrderPl(order, currentPrice);
    const orderPlPercent = getOrderPlPercent(order, currentPrice);
    const displayOpenPrice = getAverageOpenPrice(order);

    return (
        <React.Fragment>
            <tr
                hover
                key={key}
                className={getPortfolioRowClassName(selected)}
                onClick={(event) => toggleRowSelected(event, setSelected)}
            >
                <th >
                    <div className="symbol-cell">
                    {
                        order.counter > 1 ? (<span
                            size="small"
                            onClick={() => setOpen(!open)}
                            style={{ flexShrink: 0 }}
                        >
                            <span style={{
                                "fontSize": "12px",
                                "fontWeight": "700",
                                "position": "absolute",
                                "left": "0px"
                            }}> {order.counter}</span>
                            {open ? <AngleDown /> : <AngleRight />}
                        </span>

                        ) : (<span
                            size="small"
                            style={{ flexShrink: 0 }}
                        >
                            <Circle />
                        </span>)
                    }
                    <StockAvatar
                        className="avatar-sm"
                        item={order}
                        symbol={order.symbol}
                    />
                    <div className="symbol-meta">
                        <RouterLink to={"/stock/" + order.symbol} className="symbol-link">{order.symbol.toUpperCase()}</RouterLink>
                        {
                            order.dividend === "1" && (
                            <Star className="symbol-star" />
                        )}
                    </div>
                    </div>
                </th>
                <th style={{
                    padding: "5px",
                    fontWeight: "bold",
                    color: "black"
                }} align="right">

                    {currentPrice > 0 ? Number(currentPrice).toFixed(2) : '—'}
                    <span className="tooltip">
                        <AccessTime fontSize="small" aria-hidden="true" />
                        <span className="tooltiptext">Price delay 15min</span>
                    </span>
                </th>
                <th style={stylesLocal.cell} align="right">{order.quantity}</th>
                <th style={stylesLocal.cell} align="right">
                    {displayOpenPrice != null && !Number.isNaN(displayOpenPrice)
                        ? Number(displayOpenPrice).toFixed(2)
                        : '—'}
                </th>
                <th style={stylesLocal.cell} align="right">  {Number(order.open_trade).toFixed(2)}</th >
                <th style={stylesLocal.cell} align="right">
                    {currentPrice > 0 ? Number(order.quantity * currentPrice).toFixed(2) : '—'}
                </th>
                <th style={stylesLocal.cell} align="right">
                    {orderPl != null && (
                        <span style={{ color: orderPl < 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                            {formatPl(orderPl)}
                        </span>
                    )}
                </th>
                <th style={stylesLocal.cell} align="right">
                    {orderPlPercent != null && (
                        <span style={{ color: orderPlPercent < 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                            {formatPl(orderPlPercent)}%
                        </span>
                    )}
                </th>
                <th style={stylesLocal.cell} align="center">
                    {order.open_at && moment(order.open_at).zone("+00:00").format('DD/MM/YYYY')}
                </th>
                <th className="cell_edit" style={stylesLocal.cell}>
                    <ReferenceModal
                        item={order}
                        key={props.key}
                    />
                    <span variant="inherit" noWrap>
                        {order.reference}{" "}
                    </span>
                </th>
                <th style={stylesLocal.cell}>
                     <ActionBtnRight item={order} price={getPrice(order)} key={props.key} parentCounter={order.counter} delete={() => { onClickDelete(order) }} />
                    {/* <CloseModal
                        key={props.key}
                        item={order}
                        price={getPrice(order)}
                    />
                    {" "}
                    <span
                        size="small"
                        onClick={() => { onClickDelete(order) }}
                    >
                        <Trash />
                    </span> */}
                </th>
            </tr>
            <div style={{ "display": open ? "contents" : "none" }}>
                {open && order.sub_order.map((subOrder) => (
                    <tr
                        hover
                        key={subOrder.id}
                        selected={true}
                        className={getPortfolioRowClassName(selectedSubId === subOrder.id)}
                        onClick={(event) => {
                            if (event.target.closest('a, button, input, select, textarea, label, [role="button"], .cell_edit')) {
                                return;
                            }
                            setSelectedSubId((prev) => (prev === subOrder.id ? null : subOrder.id));
                        }}
                    >
                        <th style={stylesLocal.subcell}>{""}</th>
                        <th style={stylesLocal.subcell}>{""}</th>
                        <th style={stylesLocal.subcell} align="right">{subOrder.quantity}</th>
                        <th style={stylesLocal.subcell} align="right">{Number(Math.abs(subOrder.open_price)).toFixed(2)}</th>
                        <th style={stylesLocal.subcell} align="right">
                            {Number(subOrder.open_trade).toFixed(2)}
                        </th>
                        <th style={stylesLocal.subcell} align="right">
                            {currentPrice > 0 ? Number(subOrder.quantity * currentPrice).toFixed(2) : '—'}
                        </th>
                        <th style={stylesLocal.subcell} align="right">
                            {(() => {
                                const subPl = calcPl(subOrder.quantity, subOrder.open_price, currentPrice, subOrder.market);
                                return subPl != null && (
                                    <span style={{ color: subPl < 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                                        {formatPl(subPl)}
                                    </span>
                                );
                            })()}
                        </th>
                        <th style={stylesLocal.subcell} align="right">
                            {(() => {
                                const subPlPercent = calcPlPercent(subOrder.open_price, currentPrice, subOrder.market);
                                return subPlPercent != null && (
                                    <span style={{ color: subPlPercent < 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                                        {formatPl(subPlPercent)}%
                                    </span>
                                );
                            })()}
                        </th>
                        <th component="th" scope="row" style={stylesLocal.subcell} align="center">
                            {subOrder.open_at && moment(subOrder.open_at).zone("+00:00").format('DD/MM/YYYY')}
                        </th>
                        <th style={stylesLocal.subcell} className="cell_edit">
                            <ReferenceModal
                                item={subOrder}
                            />
                            <span variant="inherit" noWrap>
                                {subOrder.reference}{" "}
                            </span>
                        </th>
                        <th style={stylesLocal.subcell} >
                             <ActionBtnRight item={subOrder} symbol={order.symbol} parentCounter={order.counter} isSubOrder price={getPrice(order)} key={props.key} delete={() => { onClickDelete(subOrder) }}/>
                            {/* <CloseModal
                                key={props.key}
                                item={subOrder}
                                price={getPrice(order)}
                            />
                            {" "}
                            <span
                                size="small"
                                onClick={() => { onClickDelete(subOrder) }}
                            >
                                <Trash />
                            </span> */}
                        </th>
                    </tr>
                ))}
            </div>
        </React.Fragment>
    )
}
Row.propTypes = {
    className: PropTypes.string
};



function mapStateToProps(reducer) {
    // console.log(reducer);
    return {

        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        stock: reducer.event.stock

    };
}
const mapDispatchToProps = dispatch => ({
    removeItem: (token, params) =>
        dispatch(actions.removeItem({ token, params })),
    removeSymbol: (token, params) =>
        dispatch(actions.removeSymbol({ token, params })),

    updateReference: (token, params) =>
        dispatch(actions.updateReference({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Row);
/**
 *   {order.counter === 1 && (
                         </React.Fragment>
                    )}
                        <React.Fragment>
 * 
 *  {
                        order.counter === 1 && (
                                    </React.Fragment>
                )
                    }
                            <React.Fragment>


 *   open={openModalReference}
                                handleClose={handleClose}
                                handleSave={() => { handleSave(order) }}
                                handleChange={handleChange}
                                name={reference}
 *  open={openModalReference}
                                handleClose={handleClose}
                                handleSave={() => { handleSave(subOrder) }}
                                handleChange={handleChange}
                                name={reference}
                              
 */